/**
 * @author TomaszCzura ({}
 */
import * as auth from './../utils/auth';

// Sites
export const SITE_READ_PRIVILEGE = 'SITE_READ_PRIVILEGE';
export const SITE_ADD_PRIVILEGE = 'SITE_ADD_PRIVILEGE';
export const SITE_EDIT_PRIVILEGE = 'SITE_EDIT_PRIVILEGE';
export const SITE_DISABLE_PRIVILEGE = 'SITE_DISABLE_PRIVILEGE';
export const SITE_DELETE_PRIVILEGE = 'SITE_DELETE_PRIVILEGE';
export const SITE_ASSIGN_WKC_PRIVILEGE = 'SITE_ASSIGN_WKC_PRIVILEGE';
export const MAX_ALLOWED_DEVICES_ADD_PRIVILEGE = 'MAX_ALLOWED_DEVICES_ADD_PRIVILEGE';
export const MAX_ALLOWED_DEVICES_READ_PRIVILEGE = 'MAX_ALLOWED_DEVICES_READ_PRIVILEGE';
// Reservation
export const RESERVATION_READ_PRIVILEGE = 'RESERVATION_READ_PRIVILEGE';
export const RESERVATION_ADD_PRIVILEGE = 'RESERVATION_ADD_PRIVILEGE';
export const RESERVATION_EDIT_PRIVILEGE = 'RESERVATION_EDIT_PRIVILEGE';
export const RESERVATION_DELETE_PRIVILEGE = 'RESERVATION_DELETE_PRIVILEGE';
// User
export const USER_READ_PRIVILEGE= 'USER_READ_PRIVILEGE';
export const USER_ADD_PRIVILEGE = 'USER_ADD_PRIVILEGE';
export const USER_EDIT_PRIVILEGE = 'USER_EDIT_PRIVILEGE';
export const USER_DISABLE_PRIVILEGE = 'USER_DISABLE_PRIVILEGE';
// Mobile User
export const MOBILE_USER_READ_PRIVILEGE = 'MOBILE_USER_READ_PRIVILEGE';
export const MOBILE_USER_DELETE_PRIVILEGE = 'MOBILE_USER_DELETE_PRIVILEGE';
export const MOBILE_USER_EDIT_PRIVILEGE = 'MOBILE_USER_EDIT_PRIVILEGE';
export const MOBILE_USER_ADD_PRIVILEGE = 'MOBILE_USER_ADD_PRIVILEGE';
// Developer
export const DEVELOPER_READ_PRIVILEGE = 'DEVELOPER_READ_PRIVILEGE';
export const DEVELOPER_ADD_PRIVILEGE = 'DEVELOPER_ADD_PRIVILEGE';
export const DEVELOPER_EDIT_PRIVILEGE = 'DEVELOPER_EDIT_PRIVILEGE';
export const DEVELOPER_DELETE_PRIVILEGE = 'DEVELOPER_DELETE_PRIVILEGE';
// Log
export const LOG_READ_PRIVILEGE = 'LOG_READ_PRIVILEGE';
// Special Area
export const SPECIAL_AREA_READ_PRIVILEGE = 'SPECIAL_AREA_READ_PRIVILEGE';
export const SPECIAL_AREA_ADD_PRIVILEGE = 'SPECIAL_AREA_ADD_PRIVILEGE';
export const SPECIAL_AREA_EDIT_PRIVILEGE = 'SPECIAL_AREA_EDIT_PRIVILEGE';
export const SPECIAL_AREA_DELETE_PRIVILEGE = 'SPECIAL_AREA_DELETE_PRIVILEGE';
// Change Log
export const CHANGE_LOG_ADD_PRIVILEGE = 'CHANGE_LOG_ADD_PRIVILEGE';
export const CHANGELOG_READ_PRIVILEGE = 'CHANGELOG_READ_PRIVILEGE';
export const CHANGELOG_EDIT_PRIVILEGE = 'CHANGELOG_EDIT_PRIVILEGE';
export const CHANGELOG_DELETE_PRIVILEGE = 'CHANGELOG_DELETE_PRIVILEGE';
// Wireless Configuration
export const WIRELESS_CONFIG_READ_PRIVILEGE = 'WIRELESS_CONFIG_READ_PRIVILEGE';
export const WIRELESS_CONFIG_ADD_PRIVILEGE = 'WIRELESS_CONFIG_ADD_PRIVILEGE';
export const WIRELESS_CONFIG_EDIT_PRIVILEGE = 'WIRELESS_CONFIG_EDIT_PRIVILEGE';
export const WIRELESS_CONFIG_DELETE_PRIVILEGE = 'WIRELESS_CONFIG_DELETE_PRIVILEGE';
// Permissions
export const PERMISSIONS_READ_PRIVILEGE = 'PERMISSIONS_READ_PRIVILEGE';
export const PERMISSIONS_EDIT_PRIVILEGE = 'PERMISSIONS_EDIT_PRIVILEGE';

export function currentUserHasRight(privilege) {
  const userPermissions = auth.getCurrentUserPermissions();
  if (!userPermissions) {
    return false;
  }
  return typeof userPermissions.find((permission) => permission === privilege) !== 'undefined';
}

export function isCurrentUser(userId) {
  const loggedInUserId = auth.getCurrentUserId();
  return loggedInUserId && loggedInUserId == userId; // Saved as a string in the cookie
}
